import React from "react";

const TrainingCampPane = () => {
  return (
    <div className="training-camp-container">
      <h2>מחנה אימונים</h2>
      <div className="development-notice">
        <p>פיצ׳ר בפיתוח...</p>
      </div>
    </div>
  );
};

export default TrainingCampPane;
